// Отметки карты: круги, кольца, ромбы зданий и кресты смертей. Ими рисуют и карту,
// и образцы в легенде — поэтому легенда совпадает с картой.

export const circle = (
  context: CanvasRenderingContext2D,
  x: number,
  y: number,
  r: number,
  color: string,
) => {
  context.fillStyle = color;
  context.beginPath();
  context.arc(x, y, r, 0, Math.PI * 2);
  context.fill();
};

export const ring = (
  context: CanvasRenderingContext2D,
  x: number,
  y: number,
  r: number,
  width: number,
  color: string,
) => {
  context.strokeStyle = color;
  context.lineWidth = width;
  context.beginPath();
  context.arc(x, y, r, 0, Math.PI * 2);
  context.stroke();
};

// Здание как на игровой миникарте: ромб в цвете команды с тёмной обводкой.
// `big` — ромб в ромбе (волкер), `ring` — с тёмной серединой (патрон, страж).
export const diamond = (
  context: CanvasRenderingContext2D,
  x: number,
  y: number,
  size: number,
  color: string,
  ink: string,
  kind: "solid" | "big" | "ring",
) => {
  const layer = (side: number, fill: string) => {
    const r = side / Math.SQRT2;
    context.fillStyle = fill;
    context.beginPath();
    context.moveTo(x, y - r);
    context.lineTo(x + r, y);
    context.lineTo(x, y + r);
    context.lineTo(x - r, y);
    context.closePath();
    context.fill();
  };
  layer(size * 1.22, ink);
  layer(size, color);
  if (kind === "big") {
    layer(size * 0.56, ink);
    layer(size * 0.36, color);
  }
  if (kind === "ring") {
    layer(size * 0.42, ink);
  }
};

export const cross = (
  context: CanvasRenderingContext2D,
  x: number,
  y: number,
  size: number,
  color: string,
  ink: string,
) => {
  const r = size / 2;
  context.lineCap = "round";
  for (const [width, stroke] of [
    [size * 0.4, ink],
    [size * 0.25, color],
  ] as const) {
    context.lineWidth = width;
    context.strokeStyle = stroke;
    context.beginPath();
    context.moveTo(x - r * 0.7, y - r * 0.7);
    context.lineTo(x + r * 0.7, y + r * 0.7);
    context.moveTo(x + r * 0.7, y - r * 0.7);
    context.lineTo(x - r * 0.7, y + r * 0.7);
    context.stroke();
  }
};
